import apiClient from "./apiClient";

const fetchAllConditions = async () => {
  const response = await apiClient.get("/conditions?includeAllProps=true");
  return response.data._embedded.conditions;
};

const fetchParentConditions = async () => {
  const response = await apiClient.get("/conditions?isASubCondition=false");
  return response.data._embedded.conditions;
};

const fetchConditions = async (params = {}) => {
  const { includeAllProps = true, pageSize = 100 } = params;
  const response = await apiClient.get(
    // https://nodejs.org/api/url.html#class-urlsearchparams
    `/conditions?${new URLSearchParams({ includeAllProps, size: pageSize })}`
  );
  return response.data._embedded.conditions;
};

const fetchConditionById = async (conditionId) => {
  const response = await apiClient.get(`/conditions/${conditionId}`);
  return response.data;
};

const createCondition = async (condition) => {
  const response = await apiClient.post("/conditions", condition);
  return response.data;
};

const updateCondition = async (condition) => {
  if (condition?.uid) {
    const response = await apiClient.put(
      `/conditions/${condition.uid}`,
      condition
    );
    return response.data;
  } else {
    const response = await apiClient.post(`/conditions`, condition);
    return response.data;
  }
};

const updateQuizForCondition = async ({ condition, question }) => {
  if (question?.uid) {
    const response = await apiClient.put(`/conditions/${condition?.uid}`, {
      uid: condition?.uid,
      parentUid: condition?.parentUid,
      nodes: [
        {
          type: "quiz",
          title: `${condition?.name ?? ""} QUIZ`,
          conditionUid: condition?.uid,
          questions: [{ ...question }],
        },
      ],
    });
    return response.data;
  } else {
    const response = await apiClient.post(
      `/conditions/${condition?.uid}/quiz`,
      [{ ...question }]
    );
    return response.data;
  }
};

const deleteCondition = async (conditionId) => {
  const response = await apiClient.delete(`/conditions/${conditionId}`);
  return response.data;
};

const deletePartForConditionById = async (conditionId, pathName) => {
  const response = await apiClient.delete(
    `/conditions/${conditionId}/${pathName}`
  );
  return response.data;
};

const fetchConditionSignsAndSymptoms = async (conditionId) => {
  const response = await apiClient.get(
    `/conditions/${conditionId}/signs-symptoms`
  );
  return response.data._embedded.signsAndSymptoms;
};

const fetchConditionTreatments = async (conditionId) => {
  const response = await apiClient.get(`/conditions/${conditionId}/treatments`);
  return response.data._embedded.treatments;
};

const fetchConditionInvestigations = async (conditionId) => {
  const response = await apiClient.get(
    `/conditions/${conditionId}/investigations`
  );
  return response.data._embedded.investigations;
};

const fetchSubConditions = async (conditionId) => {
  const response = await apiClient.get(
    `/conditions/${conditionId}/sub-conditions`
  );
  return response.data._embedded.conditions;
};

const fetchSubConditionCount = async () => {
  const response = await apiClient.get("conditions?isASubCondition=true");
  return response.data.page.totalElements;
};

const fetchSuperConditionCount = async () => {
  const response = await apiClient.get("conditions?isASubCondition=false");
  return response.data.page.totalElements;
};

export {
  fetchAllConditions,
  fetchParentConditions,
  fetchSubConditions,
  fetchConditions,
  createCondition,
  updateCondition,
  updateQuizForCondition,
  deleteCondition,
  deletePartForConditionById,
  fetchConditionSignsAndSymptoms,
  fetchConditionTreatments,
  fetchConditionInvestigations,
  fetchConditionById,
  fetchSubConditionCount,
  fetchSuperConditionCount,
};
